export default __webpack_public_path__ + "static/media/whySmile.da5eb87d.png";